import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: /*#__PURE__*/_normalizeClass(`w100`)
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_3 = { class: "mt20" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { style: {"margin-top":"3px","margin-left":"-3px"} }, "テンプレを利用", -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_13 = { key: 3 }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_18 = { class: "mt20" }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VariableListsContent = _resolveComponent("VariableListsContent")!
  const _component_TextareaTag = _resolveComponent("TextareaTag")!
  const _component_TextfieldTag = _resolveComponent("TextfieldTag")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("section", {
        class: _normalizeClass(`${_ctx.isSP ? `` : ``}`),
        style: {}
      }, [
        (_ctx.rcm && _ctx.rcm.showSMSField)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(`with_white_bg rad8 ${_ctx.isSP ? `pad10` : `pad10`}`)
            }, [
              _hoisted_2,
              _createElementVNode("div", _hoisted_3, [
                (!_ctx.hideButtons)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "pointer fr rad6 borderGrey hoverGrey fs12 padw3",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addVal(`sms`)))
                    }, " +変数を追加 "))
                  : _createCommentVNode("", true),
                (_ctx.openSMSVariables)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createVNode(_component_VariableListsContent, {
                        onSelectVariable: _ctx.selectVariable,
                        type: `sms`
                      }, null, 8, ["onSelectVariable"]),
                      _hoisted_5
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_6
              ]),
              _hoisted_7,
              _createVNode(_component_TextareaTag, {
                placeholder: "先日はメールいただきましてありがとうございます。",
                class: "fl fs14 roundForm mw100",
                style: `height:300px;`,
                value: _ctx.smsContent,
                ref: "TemplateTextarea",
                onInputValue: _ctx.inputSmsContent
              }, null, 8, ["value", "onInputValue"]),
              _hoisted_8
            ], 2))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass(`with_white_bg rad8 ${_ctx.isSP ? `pad10` : `pad10`}`)
            }, [
              _hoisted_9,
              (_ctx.localTmp && _ctx.showUpdateTmpButton)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "underline fs12 fl fw600 centered alert-warning pointer",
                    style: {"margin-top":"6px"},
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.updateTmpId && _ctx.updateTmpId(...args)))
                  }, " テンプレを最新の内容に更新 "))
                : _createCommentVNode("", true),
              (!_ctx.hideButtons)
                ? (_openBlock(), _createElementBlock("label", {
                    key: 1,
                    class: _normalizeClass(`circle_button fw600 fr centered fs12 blueAround`),
                    style: {"width":"120px","padding":"4px 10px","margin-bottom":"5px"},
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.useTemplate && _ctx.useTemplate(...args)))
                  }, _hoisted_11))
                : _createCommentVNode("", true),
              (!_ctx.hideButtons)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 2,
                    class: "pointer fr rad6 borderGrey hoverGrey fs12 padw3 mt2",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.addVal(`title`)))
                  }, " +変数を追加 "))
                : _createCommentVNode("", true),
              _hoisted_12,
              (_ctx.showSubject)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createElementVNode("div", null, [
                      (_ctx.openTitleVariables)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                            _createVNode(_component_VariableListsContent, {
                              onSelectVariable: _ctx.selectVariable,
                              type: `title`
                            }, null, 8, ["onSelectVariable"]),
                            _hoisted_15
                          ]))
                        : _createCommentVNode("", true),
                      _hoisted_16
                    ]),
                    _createVNode(_component_TextfieldTag, {
                      placeholder: "件名",
                      style: {"height":"50px"},
                      class: "fl fs14 roundForm mw100",
                      value: _ctx.subject,
                      onInputValue: _ctx.inputSubject
                    }, null, 8, ["value", "onInputValue"])
                  ]))
                : _createCommentVNode("", true),
              _hoisted_17,
              _createElementVNode("div", _hoisted_18, [
                (!_ctx.hideButtons)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "pointer fr rad6 borderGrey hoverGrey fs12 padw3",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.addVal(`desc`)))
                    }, " +変数を追加 "))
                  : _createCommentVNode("", true),
                (_ctx.openDescriptionVariables)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _createVNode(_component_VariableListsContent, {
                        onSelectVariable: _ctx.selectVariable,
                        type: `desc`
                      }, null, 8, ["onSelectVariable"]),
                      _hoisted_20
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_21
              ]),
              _hoisted_22,
              _createVNode(_component_TextareaTag, {
                placeholder: "先日はメールいただきましてありがとうございます。",
                class: "fl fs14 roundForm mw100",
                style: `height:300px;`,
                value: _ctx.memo,
                ref: "TemplateTextarea",
                onInputValue: _ctx.inputMemo
              }, null, 8, ["value", "onInputValue"]),
              _hoisted_23
            ], 2))
      ], 2)
    ])
  ]))
}